import { createFileRoute } from "@tanstack/react-router";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Building2, Users, CreditCard, Package } from "lucide-react";
import { useQuery } from "convex/react";
import { api } from "@/convex/_generated/api";
import { Skeleton } from "@/components/ui/skeleton";

export const Route = createFileRoute("/_super/super/dashboard")({
  component: SuperDashboard,
});

function SuperDashboard() {
  return (
    <div className="space-y-6">
      <StatsCards />
    </div>
  );
}

function StatsCards() {
  const companiesCount = useQuery(api.companies.queries.getCompaniesCount);
  const usersCount = useQuery(api.system.users.queries.getUsersCount);
  const subscriptionsCount = useQuery(
    api.companies.subscriptions.queries.getActiveSubscriptionsCount,
  );
  const plansCount = useQuery(api.system.plans.queries.getPlansCount);

  const isLoading =
    companiesCount === undefined ||
    usersCount === undefined ||
    subscriptionsCount === undefined ||
    plansCount === undefined;

  if (isLoading) {
    return (
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        {[1, 2, 3, 4].map((i) => (
          <Card key={i}>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <Skeleton className="h-4 w-24" />
              <Skeleton className="h-4 w-4 rounded" />
            </CardHeader>
            <CardContent>
              <Skeleton className="h-8 w-16 mb-1" />
              <Skeleton className="h-3 w-32" />
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  const stats = [
    {
      title: "Total Empresas",
      value: companiesCount || 0,
      description: "Empresas registradas",
      icon: Building2,
      iconColor: "text-blue-600",
      bgColor: "bg-blue-100 dark:bg-blue-950",
    },
    {
      title: "Total Usuarios",
      value: usersCount || 0,
      description: "Usuarios en el sistema",
      icon: Users,
      iconColor: "text-green-600",
      bgColor: "bg-green-100 dark:bg-green-950",
    },
    {
      title: "Suscripciones Activas",
      value: subscriptionsCount || 0,
      description: "Suscripciones vigentes",
      icon: CreditCard,
      iconColor: "text-purple-600",
      bgColor: "bg-purple-100 dark:bg-purple-950",
    },
    {
      title: "Planes Disponibles",
      value: plansCount || 0,
      description: "Planes configurados",
      icon: Package,
      iconColor: "text-orange-600",
      bgColor: "bg-orange-100 dark:bg-orange-950",
    },
  ];

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      {stats.map((stat) => {
        const Icon = stat.icon;
        return (
          <Card key={stat.title}>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium">
                {stat.title}
              </CardTitle>
              <div className={`p-2 rounded-lg ${stat.bgColor}`}>
                <Icon className={`h-4 w-4 ${stat.iconColor}`} />
              </div>
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">{stat.value}</div>
              <p className="text-xs text-muted-foreground">
                {stat.description}
              </p>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
